module.exports = __webpack_public_path__ + "components/country-flag/static/hn-eefcc77a3294db9aabc3715d53debb92.svg";